import { useContext } from "react";

import { AgenticAiAvailabilityContext } from "@lib/agenticAi";
import type { AgenticAiState } from "@lib/agenticAi";

import { useAgenticAiExternalStoreSelector } from "@services/useAgenticAiExternalStoreSelector";

import { fullscreenModes } from "./constants";
import type { FullscreenMode } from "./constants";

const selectAgentFullscreenMode = (state: AgenticAiState): FullscreenMode | null => {
  for (const mode of fullscreenModes) {
    if (state.contextIdentifiers[mode]) {
      return mode;
    }
  }

  return null;
};

export const useAgentFullscreenMode = (): FullscreenMode | null => {
  const isAgenticAiAvailable = useContext(AgenticAiAvailabilityContext);
  const fullscreenMode = useAgenticAiExternalStoreSelector(selectAgentFullscreenMode, isAgenticAiAvailable);

  return isAgenticAiAvailable ? fullscreenMode : null;
};
